import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AttendanceRecord } from '../../../types';
import { apiClient } from '../../../api/apiClient';
import { fetchAllData } from '../../../store/slices/dataSlice';

interface AttendanceState {
  attendance: AttendanceRecord[];
  loading: boolean;
  error: string | null;
}

const initialState: AttendanceState = {
  attendance: [],
  loading: false,
  error: null,
};

// Extracted from dataSlice
export const attendanceActionAsync = createAsyncThunk(
  'attendance/action',
  async ({ empId, action, record, location }: { empId: string; action: 'clockIn' | 'clockOut'; record?: any; location?: any }, { rejectWithValue }) => {
    try {
      const payload = { action, record, location };
      const res = await apiClient.post(`/attendance/${empId}/action`, payload);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data?.message || 'Failed to update attendance');
    }
  }
);

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllData.fulfilled, (state, action) => {
        state.attendance = action.payload.attendance || [];
      })
      .addCase(attendanceActionAsync.fulfilled, (state, action) => {
        // We will keep this simple here, but complex logic can be moved here
        // like formatting the time as done in dataSlice.
        const record = action.payload.record;
        if (record) {
            const index = state.attendance.findIndex((a: any) => a.id === record._id || a._id === record._id);
            if (index !== -1) {
                state.attendance[index] = { ...state.attendance[index], ...record };
            } else {
                state.attendance.unshift(record);
            }
        }
      });
  },
});

export default attendanceSlice.reducer;
